export const reportStrings = {
  header: {
    report: "Report",
    count: "Count",
    change: "Change",
    start: "Start",
    end: "End",
  },
  labels: {
    export: "Export",
    search: "Search",
    reset: "Reset",
    exportSurverySubscribers: "Export Survery Subscribers",
    exportNewsletterSubscribers: "Export Newsletter Subscribers",
    selectFields: "Select Report Fields",
    clientFields: "Client Fields",
    caseFields: "Case Fields",
    project: "Project",
    allProjects: "All Projects",
    configureFields: "Configure Fields",
    cancel: "Cancel",
    apply: "Apply",
  },
};

export const clientFields = {
  benefits: "Benefits",
  householdIncome: "Household Income",
  disabilities: "Disability",
  newsletterSubscription: "Newsletter Subscription",
  propertyStatus: "Property Status",
  noOfBedrooms: "Number of Bedrooms",
  councilTaxBand: "Council Tax Band",
  epcRating: "EPC Rating",
  fuelPovertyIndicators: "Fuel Poverty Indicator",
  meterType: "Meter Type",
  suppliers: "Suppliers",
  fuelType: "Fuel Type",
  noOfChildren: "Number of Children",
  noOfAdults: "Number of Adults",
  surveys: "Surveys",
  householdWithChildrenUnder5: "Household with Children Under 5",
  gdpr: "GDPR Consent",
  clientMandate: "Client Mandate",
  thirdPartyMandate: "Third-Party Mandate",
};

export const caseFields = {
  status: "Case Status",
  type: "Case Type",
  project: "Project",
  referredFrom: "Referred From",
  contact: "Contact",
  energyAdviceInterventions: "Energy Advice Interventions",
  energyAppointments: "Energy Appointments",
  fuelBankVouchers: "Fuel Bank Vouchers",
  savings: "Savings",
  potentialSavings: "Potential Savings",
  additionalSupport: "Additional Support",
};

export const reportFields = {
  entityType: "Entity Counts",
  ...clientFields,
  ...caseFields,
};

// Mapping when field name !== tag group name
export const tagGroupMapping: Record<string, string> = {
  status: "caseStatus",
  type: "caseType",
  project: "projects",
};
